import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {
  apiEndpoint: any;
  constructor(private httpClient: HttpClient) { 
    this.apiEndpoint = environment.APIEndpoint;

  }
  handleError(error) {

    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(error);
  }
  
  personalData(page,formData): Observable<any> {
    let params = new HttpParams();
    params = params.append('page', page);
    let body = {};
    if(page == 'personal'){
      body = {
        "name": formData.name,
        "last_name": formData.last_name,
        "username": formData.username,
        "email": formData.email,
        "mobile": formData.mobile,
        "avatar_url": formData.avatar_url,
        "institute": formData.institute,
        "about": formData.about,
        "role":formData.role,
        "facebook": formData.facebook,
        "linkedin": formData.linkedin,
        "instagram": formData.instagram,
        "twitter": formData.twitter,
        "fields_of_interest":formData.fields_of_interest   
       }
    } else if(page == 'account_settings'){
        body = {
          "old_password": formData.old_password,
          "new_password": formData.new_password,
          "confirm_password": formData.confirm_password
        } 
      } else if(page == 'education'){
        body = formData;        
      } else if(page == 'professional'){
        body = formData;
      } else if(page == 'profile_settings'){
        body = {
            "show_profile" : formData.show_profile,
            "show_username" : formData.show_username, 
            "show_organization" : formData.show_organization,
            "show_social_media" : formData.show_social_media,
            "hrs_study_today" :  formData.hrs_study_today,
            "show_email" : formData.show_email,
            "show_phone" : formData.show_phone,
            "show_courses" : formData.show_courses
        }
     } else if(page == 'resume'){      
          body = {
              "doc_id" : formData.doc_id,
              "doc_path" : formData.doc_path,
              "video_id":formData.video_id,
              "video_path":formData.video_path, 
              "deleted_file":formData.deleted_file             
          }
     }
    return this.httpClient.patch<any>(this.apiEndpoint + '/user_profile', body, {params}).pipe(catchError(this.handleError));
  }

  // Account Personal Api
  getProfileData(): Observable<any> {
    return this.httpClient.get<any>(this.apiEndpoint + '/profile/personal').pipe(catchError(this.handleError));
  }
  getEduData(): Observable<any> {
    return this.httpClient.get<any>(this.apiEndpoint + '/profile/education').pipe(catchError(this.handleError));
  }
  getProData(): Observable<any> {
    return this.httpClient.get<any>(this.apiEndpoint + '/profile/professional').pipe(catchError(this.handleError));
  }

  getAccountSetting(): Observable<any>{
    return this.httpClient.get<any>(this.apiEndpoint + '/profile/settings').pipe(catchError(this.handleError));
  }
  getPrivacySetting(): Observable<any>{
    return this.httpClient.get<any>(this.apiEndpoint + '/profile/privacy').pipe(catchError(this.handleError));
  }
  getResumeInfo(): Observable<any>{
    return this.httpClient.get<any>(this.apiEndpoint + '/profile/resume').pipe(catchError(this.handleError));
  }

  /**
   * To get mentor slots
   */
  getSlotsSettings(): Observable<any> {
    return this.httpClient.get<any>(this.apiEndpoint + '/mentorship/get_mentor_slots').pipe(catchError(this.handleError));
  }

  /**
  * To save mentor slots
  * @param {object} postData - to get the slots data
  */
  saveSlotsSettings(postData: any): Observable<any> {
    return this.httpClient.post(this.apiEndpoint + '/mentorship/save_mentor_slots', postData).pipe(catchError(this.handleError));
  }

  /**
   * To get organisations data
   */
  getOrganisationsData(): Observable<any> {
    return this.httpClient.get<any>(this.apiEndpoint + '/mentorship/get_organisations').pipe(catchError(this.handleError));
  }

    /**
   * To get organisations based Users
   */
    getOrganisationsUser(org_id:string): Observable<any> {
      let params = new HttpParams();
      params = params.append('org_id', org_id);
      params = params.append('role', 'student');

      return this.httpClient.get<any>(this.apiEndpoint + '/organization/users', {params}).pipe(catchError(this.handleError));
    }

  /**
  * To save mentor accessible organisations
  * @param {object} postData - to get the organisations data
  */
  saveOrganisationsData(postData: any): Observable<any> {
    return this.httpClient.post(this.apiEndpoint + '/mentorship/save_accessible_organisations', postData).pipe(catchError(this.handleError));
  }

  /**
  * To get skills data
  */
  getSkillsData(): Observable<any> {
    return this.httpClient.get<any>(this.apiEndpoint + '/mentorship/get_skills').pipe(catchError(this.handleError));
  }

  /**
  * To save user skills
  * @param {object} postData - to get the skills data
  */
  saveSkillsData(postData: any): Observable<any> {
    return this.httpClient.post(this.apiEndpoint + '/mentorship/save_user_skills', postData).pipe(catchError(this.handleError));
  }
}


